import _property from 'lodash/property';
export var VENDOR_MODEL = {
  VENDOR_NAME: 'vendorName',
  ALTERNATE_NAME: 'alternateName',
  PARENT_COMPANY: 'parentCompany',
  DEFINE_ORGANIZATON_TYPE: 'otherOrganizationType',
  VENDOR_TYPE: 'vendorType'
};

var vendorDisplayId = _property('vendorDisplayId');

var vendorName = _property(VENDOR_MODEL.VENDOR_NAME);

var alternateName = _property(VENDOR_MODEL.ALTERNATE_NAME);

var parentCompany = _property(VENDOR_MODEL.PARENT_COMPANY); // TODO : change the rest of the reader using VENDOR_MODEL


var createdTime = _property('createdTime');

var modifiedTime = _property('modifiedTime');

var lastTransactionTime = _property('lastTransactionTime');

var creditLimit = _property('creditLimit');

var deliverable = _property('deliverable');

var taxInfo = _property('taxInfo');

var goodsAndServices = _property('goodsAndServices');

var sites = _property('sites');

var vendorCategories = _property('vendorCategories');

var vendorType = _property('vendorType');

var vendorStatus = _property('vendorStatus');

var isPurchaseOrderRequired = _property('isPurchaseOrderRequired');

var poRequired = _property('poRequired');

var goodsAndService = _property('deliverable.goodsAndService');

var opCodes = _property('deliverable.opCodes');

var parts = _property('deliverable.parts');

var socialSecurityNumber = _property('taxInfo.socialSecurityNumber');

var federalTaxId = _property('taxInfo.federalTaxId');

var organizationType = _property('taxInfo.organizationType');

var issue1099 = _property('taxInfo.issue1099');

var printAmount = _property('taxInfo.printAmount');

var printBoxName = _property('taxInfo.printBoxName');

var printName = _property('taxInfo.printName');

var id = _property('id');

var dealerId = _property('dealerId');

var externalId = _property('externalId');

var attachments = _property('attachments');

var hold = _property('paymentHoldInformation.onHold');

var reasonForHolding = _property('paymentHoldInformation.reasonForHolding');

var linkedVendors = _property('linkedVendors');

var vendorId = _property('vendorId');

var invoiceOffsetGLAccount = _property('invoiceOffsetGLAccount');

var phone = _property('phone');

var VENDOR_READER = {
  alternateName: alternateName,
  createdTime: createdTime,
  creditLimit: creditLimit,
  deliverable: deliverable,
  federalTaxId: federalTaxId,
  goodsAndService: goodsAndService,
  goodsAndServices: goodsAndServices,
  id: id,
  issue1099: issue1099,
  isPurchaseOrderRequired: isPurchaseOrderRequired,
  lastTransactionTime: lastTransactionTime,
  modifiedTime: modifiedTime,
  opCodes: opCodes,
  organizationType: organizationType,
  parentCompany: parentCompany,
  parts: parts,
  poRequired: poRequired,
  printAmount: printAmount,
  printBoxName: printBoxName,
  printName: printName,
  sites: sites,
  socialSecurityNumber: socialSecurityNumber,
  taxInfo: taxInfo,
  vendorCategories: vendorCategories,
  vendorDisplayId: vendorDisplayId,
  vendorName: vendorName,
  vendorStatus: vendorStatus,
  vendorType: vendorType,
  dealerId: dealerId,
  externalId: externalId,
  attachments: attachments,
  hold: hold,
  reasonForHolding: reasonForHolding,
  linkedVendors: linkedVendors,
  vendorId: vendorId,
  invoiceOffsetGLAccount: invoiceOffsetGLAccount
};
export default VENDOR_READER;